import { cm } from 'src/utils/classNames';
import MarketsSearchBar from '../MarketSelector/MarketsSearchBar';
import Checkbox from 'src/components/primitives/Checkbox/Checkbox';

export const SpotMarketFilterAndSearch = ({
	isFilterWalletAssets,
	onFilterWalletAssets,
	searchValue,
	onSearch,
	needFilterWalletAssets = true,
	className,
	searchInputClassName,
}: {
	isFilterWalletAssets?: boolean;
	onFilterWalletAssets?: () => void;
	searchValue: string;
	onSearch: (search: string) => void;
	searchPlaceholder?: string;
	needFilterWalletAssets?: boolean;
	className?: string;
	searchInputClassName?: string;
}) => {
	return (
		<div
			className={cm(
				'flex flex-row-reverse items-center justify-start gap-4 xs:justify-end sm:flex-row',
				className
			)}
		>
			{needFilterWalletAssets && (
				<div>
					<Checkbox.Default
						id="only-assets-in-my-wallet"
						label="Wallet Balance"
						checked={isFilterWalletAssets ?? false}
						onCheckedChange={onFilterWalletAssets}
					/>
				</div>
			)}
			<div className={cm('w-full min-w-[220px]', searchInputClassName)}>
				<MarketsSearchBar
					id="spot-market-search"
					searchValue={searchValue}
					setSearchValue={onSearch}
					placeholder="Search by token name"
					bgClassName="bg-main-bg"
					autoFocus={false}
				/>
			</div>
		</div>
	);
};
